var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"max-width":"900px"}},[_c('div',{staticClass:"text-center"},[_c('h1',[_vm._v(" An error occurred ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }